<div #rentalItemDetails class="details">
  <div class="details-container">
    <div style="margin-bottom: 2rem">
      <scale-button
        icon-position="start"
        (click)="goBack.emit()"
        size="small"
        variant="secondary-white">
        <scale-icon-navigation-left></scale-icon-navigation-left>
        {{ 'rem.properties.label__back' | translate }}
      </scale-button>
    </div>

    <div class="file-previews" *ngIf="isDesktopView">
      <div
        class="file-preview"
        *ngFor="let item of items; let i = index"
        [lightbox]="i"
        [gallery]="galleryId"
        role="button"
        tabindex="0"
        [attr.aria-label]="'Bild vergrößern: ' + (i + 1)"
        (keydown.enter)="openLightbox(i)"
        (keydown.space)="openLightbox(i); $event.preventDefault()">
        <img
          class="rental-details-image"
          [src]="item.data.thumb"
          onerror="
            this.onerror = null;
            this.src = '../../../assets/icons/scan_delete.svg';
          " />
      </div>
    </div>

    <div class="file-preview-mobile" *ngIf="!isDesktopView">
      <gallery
        #gallery
        [counter]="false"
        [dots]="true"
        [thumb]="false"
        [imageSize]="'cover'"
        [items]="items"></gallery>
    </div>

    <h2>
      {{ location.title }}
    </h2>

    <h3 style="display: flex; gap: 1.25rem; font-style: italic">
      <span *ngIf="location.specificPrice; else noPrice">
        {{ location.specificPrice }}
      </span>
      <ng-template #noPrice>
        <span>{{ 'rem.properties.label__price_on_request' | translate }}</span>
      </ng-template>
      <span *ngIf="location.areaSpecification">
        {{ location.areaSpecification }}
      </span>
    </h3>
    <hr class="thin" *ngIf="location?.description" />

    <p *ngIf="location?.description">{{ location.description }}</p>

    <hr class="thin" *ngIf="location?.links.length > 0" />
    <div style="margin-top: 3.75rem; margin-bottom: 1.25rem; font-weight: bold">
      <p *ngIf="location?.links.length > 0">
        <span
          *ngIf="
            location?.additionalInformation;
            else additionalInformationDefault
          ">
          {{ location.additionalInformation }}
        </span>
        <ng-template #additionalInformationDefault>
          <span>
            {{ 'website_edit.rental.further_information_default' | translate }}
          </span>
        </ng-template>
      </p>
    </div>

    <div class="link-container">
      <a
        *ngFor="let link of location.links"
        [href]="link.link"
        style="color: white; display: flex; gap: 0.625rem; font-size: large"
        target="_blank"
        rel="noopener noreferrer"
        [attr.aria-label]="link.linkDisplayName + ' (öffnet in neuem Tab)'"
        class="custom-immoscout-button">
        <img
          src="assets/icons/Link.png"
          alt="Datei"
          style="width: 1.25rem; height: 1.25rem" />
        <span style="text-decoration: underline">
          {{ link.linkDisplayName }}
        </span>
        <mat-icon style="font-size: 1.25rem">launch</mat-icon>
      </a>
    </div>

    <img
      src="assets/images/Vermietung.png"
      alt="Gebäude Vermietung"
      class="info-img" />
  </div>
</div>
